<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-input v-model="keyword" placeholder="姓名" style="width: 250px" size="small" clearable></el-input>
        <el-input v-model="keyword2" placeholder="工种" style="width: 250px;margin-left: 5px;" size="small" clearable></el-input>
        <el-button type="primary" size="small" style="margin-left: 10px" @click="search"><i class="el-icon-search" style="margin-right: 5px"></i>搜索</el-button>
        <el-button size="small" @click="reset"><i class="el-icon-refresh-left" style="margin-right: 5px"></i>重置</el-button>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="add"><i class="el-icon-plus" style="margin-right: 5px"></i>新增</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="calc(100% - 72px)" style="width: 100%">
          <el-table-column align="center" label="ID" width="80" prop="id"></el-table-column>
          <el-table-column align="center" label="姓名" min-width="100" prop="renyuan"></el-table-column>
          <el-table-column align="center" label="工种" min-width="100" prop="gongzhong"></el-table-column>
          <el-table-column align="center" label="应出勤天数" min-width="100" prop="yingchuqin"></el-table-column>
          <el-table-column align="center" label="添加时间" min-width="100" prop="createTime"></el-table-column>
          <el-table-column align="center" label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row.id)">编辑</el-button>
              <el-button type="text" @click="del(scope.row.id)" style="color: #f56c6c">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding: 20px; text-align: center">
          <el-pagination
            background
            layout="total, sizes,prev, pager, next, jumper"
            @size-change="pageSizeChange"
            :total="total"
            @current-change="pageChange"
            :current-page="pageNum"
            :page-size="pageSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加修改弹窗 -->
    <el-dialog title="编辑" :visible.sync="editModal">
      <el-form :model="editForm" ref="EditForm" label-width="150px" :rules="rules">
        <el-form-item label="姓名" prop="renyuan">
          <el-input v-model="editForm.renyuan"></el-input>
        </el-form-item>
        <el-form-item label="工种" prop="gongzhong">
          <el-input v-model="editForm.gongzhong"></el-input>
        </el-form-item>
        <el-form-item label="应出勤天数" prop="yingchuqin">
          <el-input-number v-model="editForm.yingchuqin" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editModal = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
const editFormData = () => {
  return {
    renyuan: "",
    gongzhong: "",
    yingchuqin: 0,
  }
}
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keyword2: "",
      keywordType: 1,
      editModal: false,
      editForm: editFormData(),
      rules: {
        
      },
      sf: '',
    }
  },

  created() {
    this.sf = localStorage.sf
    this.getList()
  },

  methods: {
    
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.keyword2 = ""
      this.search()
    },
    
    add() {
      let form = JSON.parse(JSON.stringify(this.editForm))
      this.editForm = JSON.parse(JSON.stringify(editFormData()))
      this.editForm.gongzhong = form.gongzhong
      this.editForm.yingchuqin = form.yingchuqin
      this.editModal = true
    },

    edit(id) {
      this.$request.post('/index.php/admin/Ordermodel/gzhuizongMbInfo', {id: id}).then((res) => {
        this.editForm = res.data.data
        this.editModal = true
      }).catch(err => {
        console.log(err)
      })
    },

    del(id) {
      this.$confirm("请确认是否删除该条信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request.post('/index.php/admin/Ordermodel/gzhuizongMbDel', {id: id}).then((res) => {
          this.$message.success(res.data.msg)
          this.getList()
        }).catch(err => {
          console.log(err)
        })
      })
    },

    save() {
      this.$refs["EditForm"].validate((valid) => {
        if (valid) {
          let data = this.editForm
          this.$request.post('/index.php/admin/Ordermodel/gzhuizongMbSave', data).then((res) => {
            this.$message.success(res.data.msg)
            this.editModal = false
            this.getList()
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },


    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        page: this.pageNum,
        num: this.pageSize,
      }
      if(this.keyword) {
        data.keyword = this.keyword
      }
      if(this.keyword2) {
        data.keyword2 = this.keyword2
      }
      this.$request.post('/index.php/admin/Ordermodel/gzhuizongMbList', data).then((res) => {
        this.list = res.data.data
        this.total = res.data.count
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
